import { render } from "./PopupSelectControl.vue?vue&type=template&id=18a5a5a4"
import script from "./PopupSelectControl.vue?vue&type=script&lang=js"
export * from "./PopupSelectControl.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__